import { Injectable } from '@angular/core';
import * as _ from 'lodash';   
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './config/app.config';
import { of } from 'rxjs';
import { CacheService } from './cache.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
const allowedStates = ['private.dashboard', 'private.logout', 'private.profilelink', 'private.profilelink.edit'];

@Injectable({
  providedIn: 'root'
})

export class PrivilegesService extends DataService {

  constructor(appConfig: AppConfig, http: HttpClient,public ngxService:NgxUiLoaderService) {
    super(appConfig, http);
  }
  
  CheckStatePrevilege = function (stateName) {
   
    stateName = stateName.toLowerCase();
    return parseAndCheckPrevilege();

    function parseAndCheckPrevilege() {
      if (stateName.endsWith('.view')) { // remove the view part from state name because it comes from menu link and not from state names
        stateName = splitString(stateName, stateName.lastIndexOf('.view'))[0];
      }
      if (stateName.startsWith('public')) {
        return true;
      }
      if (allowedStates.indexOf(stateName) > -1) {
        return true;
      }
      const stateParts = PartitionStates();
      const filteredLoggedInPrevileges = FilterPrevilegeByEntityName(stateParts[0]);

      if (!filteredLoggedInPrevileges) { // If previlege for entity is not found
        return false;
      }

      if (stateParts.length === 1) { // .Add and .Edit is not in state name
        //View is already removed from state name so if 
        //.view comes in the state or not it is treated the same
        return CheckPrevilegeInEntity(filteredLoggedInPrevileges, 'View');
      }
      else if (stateParts[stateParts.length - 1].toLowerCase().endsWith('add')) {
        return CheckPrevilegeInEntity(filteredLoggedInPrevileges, 'Create');
      }
      else if (stateParts[stateParts.length - 1].toLowerCase().endsWith('edit')) {
        return CheckPrevilegeInEntity(filteredLoggedInPrevileges, 'Edit');
      }
     
      return false;
    }
    function PartitionStates() {
      if (stateName.lastIndexOf('.') < 0) {
        return [stateName];
      }
      let splitStates = [stateName];
      if (stateName.endsWith('.add')) {
        splitStates = splitString(stateName, stateName.lastIndexOf('.add'));
      } else if (stateName.endsWith('.edit')) {
        splitStates = splitString(stateName, stateName.lastIndexOf('.edit'));
      }
      return splitStates;
    }

  

  function FilterPrevilegeByEntityName(entityName) {
    const userPrevileges = JSON.parse(localStorage.getItem('LoggedInUserPrivileges'));
    if (userPrevileges) {
      const actualName = Object.keys(userPrevileges.entities).find(function (x) { return x.toLowerCase() === entityName; })
      return userPrevileges.entities[actualName];
    }
    return null;
  };
  function CheckPrevilegeInEntity(entityPrevilegeItem, previlegeName) {
    if (entityPrevilegeItem) {
      return entityPrevilegeItem.privileges.hasOwnProperty(previlegeName); 
      // Check if key with the previlegeName is there in privileges object
    }
    return false;
  };
  function splitString(stringObj, index) {
    return [stringObj.substring(0, index), stringObj.substring(index)];
  };

  }
}
